import type { GroupState } from 'components/CustomSwitchBtn/CustomSwitchBtn';

const VALID_MQTT_GROUP_STATES: readonly GroupState[] = ['ENABLED', 'DISABLED', 'PARTIAL', 'PENDING'];

export const extractMqttStringState = (message: any): GroupState | null => {
    const candidate = message?.groupState ?? message?.loadState ?? message?.state;
    if (typeof candidate !== 'string') return null;
    const upper = candidate.toUpperCase() as GroupState;
    return VALID_MQTT_GROUP_STATES.includes(upper) ? upper : null;
};

export const extractMqttBoolState = (message: any): GroupState | null => {
    if (typeof message?.isEnabled === 'boolean') return message.isEnabled ? 'ENABLED' : 'DISABLED';
    if (typeof message?.isGroupEnabledOrDisabled === 'boolean') {
        return message.isGroupEnabledOrDisabled ? 'ENABLED' : 'DISABLED';
    }
    return null;
};

export const decodeMqttGroupState = (message: any): GroupState | null =>
    extractMqttStringState(message) ?? extractMqttBoolState(message);

const DEFAULT_DETAILS_WIDGET_TYPES = new Set(['details', 'properties', 'settings']);

export const isDefaultDetailsWidget = (widgetTypeId: any): boolean => DEFAULT_DETAILS_WIDGET_TYPES.has(widgetTypeId);

export const computeMinRowsForWidget = (widget: any): number => {
    void widget;
    return 2;
};
